module.exports = __webpack_public_path__ + "img/bgc23.19245322.png";